import Executor from "./executor";

/**
 * Overmind - manages multiple executors running in parallel
 * Reference: quadra/source/overmind.h and overmind.cc
 */
export default class Overmind {
  private executors: Executor[] = [];
  private paused: boolean = false;
  public done: boolean = false;
  public framecount: number = 0;

  constructor() {
    this.framecount = 0;
    this.paused = false;
    this.done = false;
  }

  /**
   * Step all executors (called each frame)
   * Reference: quadra/source/overmind.cc:53-74
   */
  step(): void {
    if (this.paused) {
      return;
    }
    this.framecount++;
    
    // Step all executors
    for (let i = 0; i < this.executors.length; i++) {
      const executor = this.executors[i];
      if (!executor) {
        this.executors.splice(i, 1);
        i--;
      } else {
        executor.step();
        if (executor.done) {
          if (executor.selfDestruct) {
            // Executor will clean itself up
          }
          this.executors.splice(i, 1);
          i--;
        }
      }
    }
    
    if (this.executors.length === 0) {
      this.done = true;
    }
  }

  /**
   * Start a new executor (adds it to the list)
   * Reference: quadra/source/overmind.cc:76-79
   */
  start(executor: Executor): void {
    this.executors.push(executor);
    this.done = false;
  }

  /**
   * Stop an executor (removes it from the list)
   * Reference: quadra/source/overmind.cc:81-89
   */
  stop(executor: Executor): void {
    const index = this.executors.indexOf(executor);
    if (index !== -1) {
      if (executor.selfDestruct) {
        // Executor will clean itself up
      }
      this.executors[index] = null as any; // Mark as null, will be removed in step()
    }
  }

  /**
   * Pause all executors
   * Reference: quadra/source/overmind.cc:45-47
   */
  pause(): void {
    this.paused = true;
  }

  /**
   * Unpause all executors
   * Reference: quadra/source/overmind.cc:49-51
   */
  unpause(): void {
    this.paused = false;
  }

  /**
   * Clean up all executors
   * Reference: quadra/source/overmind.cc:36-43
   */
  cleanUp(): void {
    while (this.executors.length > 0) {
      const executor = this.executors.pop();
      if (executor && executor.selfDestruct) {
        // Executor will clean itself up
      }
    }
  }
}

